import { pythonBaseUrl } from "../App_Settings/app_settings";

/**
 * Send demo request email
 * @param {Object} formData - Form data containing name, email, company, message
 * @returns {Promise} - Promise that resolves when email is sent
 */
export const sendDemoRequestEmail = async (formData) => {
  try {
    const response = await fetch(`${pythonBaseUrl}/Email/SendDemoRequest`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        company: formData.company,
        message: formData.message,
        subject: "Demo Request - Comply Extractor",
        timestamp: new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to send demo request email: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error sending demo request email:", error);
    throw new Error("Failed to send demo request. Please try again later.");
  }
};

/**
 * Send registration email
 * @param {Object} formData - Registration form data
 * @returns {Promise} - Promise that resolves when email is sent
 */
export const sendRegistrationEmail = async (formData) => {
  try {
    const response = await fetch(`${pythonBaseUrl}/Email/SendRegistrationEmail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.username,
        organizationName: formData.organizationName,
        subject: "Welcome to Comply Extractor - Registration Confirmation",
        timestamp: new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to send registration email: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error sending registration email:", error);
    throw new Error("Failed to send registration email. Please try again later.");
  }
};

/**
 * Send general contact email
 * @param {Object} emailData - Email data
 * @returns {Promise} - Promise that resolves when email is sent
 */
export const sendContactEmail = async (emailData) => {
  try {
    const response = await fetch(`${pythonBaseUrl}/Email/SendContactEmail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...emailData,
        timestamp: new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to send contact email: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error sending contact email:", error);
    throw new Error("Failed to send email. Please try again later.");
  }
};
